import './DataTableWrapper.css';
import { DataTableBuilder } from './builders/DataTableBuilder';
import { DataTableAdapter } from './adapter/DataTableAdapter';
import { _adapterRegistry } from './shared/Constants';

/**
 * DataTable Wrapper (v2) - Modular Build
 * A fluent, declarative wrapper for DataTables.net
 */

// ── DataTables Global Search Extension ─────────────────────────────────
if (window.jQuery && window.jQuery.fn.dataTable) {
    const $ = window.jQuery;
    $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
        const adapter = _adapterRegistry.get(settings.nTable);
        if (!adapter) return true;
        return adapter._applyAdvancedFilters(data, dataIndex);
    });
}

// ── Global Exposure ───────────────────────────────────────────────────
if (typeof window !== 'undefined') {
    window.DataTableBuilder = DataTableBuilder;
    window.DataTableAdapter = DataTableAdapter;
}

export { DataTableBuilder };

